<template>
    <div class="common">
    </div>
</template>

<script>
const baseUrl = 'http://47.108.21.146:7777/'
// const baseUrl = 'http://127.0.0.1:7777/'
export default {
  name: 'Common',
  baseUrl
}
</script>



// WEBPACK FOOTER //
// src/components/Common.vue